import { apiFetch } from './client'

interface ServerConsentRecord {
  uuid: string
  analytics: boolean
  marketing: boolean
  policy_version: string
  recorded_at: string
  is_pending: boolean
}

export interface ConsentRecord {
  uuid: string
  analytics: boolean
  marketing: boolean
  policyVersion: string
  recordedAt: string
  isPending: boolean
}

export interface RecordConsentPayload {
  analytics: boolean
  marketing: boolean
  sessionToken: string
}

function toConsentRecord(s: ServerConsentRecord): ConsentRecord {
  return {
    uuid: s.uuid,
    analytics: s.analytics,
    marketing: s.marketing,
    policyVersion: s.policy_version,
    recordedAt: s.recorded_at,
    isPending: s.is_pending,
  }
}

export async function recordConsent(payload: RecordConsentPayload): Promise<ConsentRecord> {
  const res = await apiFetch<{ data: ServerConsentRecord }>('/consent', {
    method: 'POST',
    body: JSON.stringify(payload),
  })
  return toConsentRecord(res.data)
}

export async function fetchCurrentConsent(sessionToken: string): Promise<ConsentRecord> {
  const res = await apiFetch<{ data: ServerConsentRecord }>(`/consent/current?sessionToken=${encodeURIComponent(sessionToken)}`)
  return toConsentRecord(res.data)
}
